import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Table } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { convertToDisplay, convertToDisplayWithTime } from 'app/shared/util/date-utils';
import { defaultEventTypes, IEvent, IEventTypes } from 'app/shared/model/event.model';

export const isEventHasEnabledSessions = (event: IEvent) => {
  if (event && event.sessions && event.sessions.find(s => s.enabled === true)) return true;
  else return false;
};

export const isIgnoreZoneSeat = (event: IEvent) => {
  const eventTypes: IEventTypes = event.types && event.types !== '' ? JSON.parse(event.types) : defaultEventTypes;
  return eventTypes.ignoreZoneSeat;
};

export const genTransactionTable = (transaction, onPreviewClick, ignoreZoneSeat = false) => {
  const { deliveryCharge, remark } = transaction;
  const displayRows = [];
  let qty = 0;

  const compare = (a, b) => {
    if (a.displaySeat < b.displaySeat) return -1;
    if (a.displaySeat > b.displaySeat) return 1;
    return 0;
  };

  if (transaction && Object.keys(transaction).length !== 0 && transaction.tickets.length > 0) {
    qty = transaction.tickets.length;
    transaction.tickets.sort(compare);
    transaction.tickets.forEach(tic => {
      const row = displayRows.find(r => r.session.id === tic.session.id && r.zone.id === tic.zone.id);
      const seatNo = tic.row + (tic.displaySeat + '');
      if (row) {
        row.tics.push(seatNo);
        row.tickets.push(tic);
      } else {
        displayRows.push({
          session: tic.session,
          zone: tic.zone,
          price: tic.pricing.price,
          handlingFee: tic.pricing.handlingFee,
          tics: [seatNo],
          tickets: [tic]
        });
      }
    });
  }

  return (
    <Table hover responsive size="sm">
      <thead>
        <tr>
          <th>
            <Translate contentKey="order.personalinfo.session">Session</Translate>
          </th>
          {!ignoreZoneSeat && (
            <th>
              <Translate contentKey="order.personalinfo.zone">Zone</Translate>
            </th>
          )}
          {!ignoreZoneSeat && (
            <th>
              <Translate contentKey="order.personalinfo.seatnumber">Seat Number - Price</Translate> (HKD$)
            </th>
          )}
          <th>
            <Translate contentKey="order.personalinfo.handlingfee">Handling Fee</Translate> (HKD)
          </th>
          <th>
            <Translate contentKey="order.personalinfo.total">Total</Translate> (HKD)
          </th>
        </tr>
      </thead>
      <tbody>
        {displayRows.length > 0 &&
          displayRows.map((r, i) => (
            <tr key={i}>
              <td>{convertToDisplayWithTime(r.session.startTime)}</td>
              {!ignoreZoneSeat && <td>{r.zone.name}</td>}
              {!ignoreZoneSeat && (
                <td>
                  {r.zone.freeSeating ? 'FREE STANDING' + ' X ' + r.tics.length : r.tics.join(',')} - ${r.price}
                  <br />
                  {!r.zone.freeSeating && (
                    <a onClick={() => onPreviewClick(r.tickets, r.zone.name)} className="pl-2 text-secondary">
                      <Translate contentKey="order.personalinfo.preview">preview</Translate>
                      <FontAwesomeIcon icon="info-circle" />
                    </a>
                  )}
                </td>
              )}
              <td>${r.handlingFee}</td>
              <td>${r.price + r.handlingFee}</td>
            </tr>
          ))}
        {deliveryCharge &&
          deliveryCharge !== '' && (
            <tr>
              <td />
              {!ignoreZoneSeat && <td />}
              {!ignoreZoneSeat && <td />}
              <td>
                {remark.indexOf('DELIVERY_HK') >= 0 && <Translate contentKey="order.personalinfo.hk">HK</Translate>}
                {remark.indexOf('DELIVERY_MACAU') >= 0 && <Translate contentKey="order.personalinfo.macau">Macau</Translate>}
                {remark.indexOf('DELIVERY_ONSITE') >= 0 && <Translate contentKey="order.personalinfo.onsite">Onsite</Translate>}
              </td>
              <td>${deliveryCharge}</td>
            </tr>
          )}
        <tr>
          <td />
          {/*<td />
          <td/>*/}
          <td>
            <Translate contentKey="order.personalinfo.totalwithqty" interpolate={{ qty }}>
              Total
            </Translate>
          </td>
          <td>${transaction.amount}</td>
        </tr>
      </tbody>
    </Table>
  );
};
